import { CraPieChart } from "../../pie-chart/CraPieChart";
import { Box, HStack, Stack } from "@chakra-ui/react";
import { CraColoringSelector } from "../../CraColoring/CraColoringSelector";
import { CraColoringLegend } from "../../CraColoring/CraColoringLegend";
import { CraColoring } from "../../../../../map/models/CraColoring";
import { ProjectPermissions } from "../../../../../project/models/Project";

export const PieChartCraColoring: React.FC<{
  value: CraColoring;
  onChange: (value: CraColoring) => void;
  projectPermissions?: ProjectPermissions;
}> = ({ value, onChange, projectPermissions }) => {
  return (
    <Stack w="100%">
      {projectPermissions?.canManageResults && (
        <HStack justifyContent="center" pt={4} px={4}>
          <CraColoringSelector value={value} onChange={onChange} />
        </HStack>
      )}
      <HStack justifyContent="center" gap={0}>
        <CraPieChart craColoring={value} />
        <Box py={2} pr={4} maxW="200px" minWidth="160px" flexShrink={0}>
          <CraColoringLegend craColoring={value} />
        </Box>
      </HStack>
    </Stack>
  );
};
